import { createNS } from "@ontologies/core";
/** Function to create arbitrary terms within the 'XML Schema Datatypes in RDF and OWL' ontology */
export const ns = createNS("http://www.w3.org/2001/XMLSchema#");
/* Classes */
export const string = /*#__PURE__*/ ns("string");
export const xsdboolean = /*#__PURE__*/ ns("boolean");
export const decimal = /*#__PURE__*/ ns("decimal");
export const xsdfloat = /*#__PURE__*/ ns("float");
export const xsddouble = /*#__PURE__*/ ns("double");
export const duration = /*#__PURE__*/ ns("duration");
export const dateTime = /*#__PURE__*/ ns("dateTime");
export const time = /*#__PURE__*/ ns("time");
export const date = /*#__PURE__*/ ns("date");
export const gYearMonth = /*#__PURE__*/ ns("gYearMonth");
export const gYear = /*#__PURE__*/ ns("gYear");
export const gMonthDay = /*#__PURE__*/ ns("gMonthDay");
export const gDay = /*#__PURE__*/ ns("gDay");
export const gMonth = /*#__PURE__*/ ns("gMonth");
export const hexBinary = /*#__PURE__*/ ns("hexBinary");
export const base64Binary = /*#__PURE__*/ ns("base64Binary");
export const anyURI = /*#__PURE__*/ ns("anyURI");
export const normalizedString = /*#__PURE__*/ ns("normalizedString");
export const token = /*#__PURE__*/ ns("token");
export const language = /*#__PURE__*/ ns("language");
export const NMTOKEN = /*#__PURE__*/ ns("NMTOKEN");
export const Name = /*#__PURE__*/ ns("Name");
export const NCName = /*#__PURE__*/ ns("NCName");
export const integer = /*#__PURE__*/ ns("integer");
export const nonPositiveInteger = /*#__PURE__*/ ns("nonPositiveInteger");
export const negativeInteger = /*#__PURE__*/ ns("negativeInteger");
export const xsdlong = /*#__PURE__*/ ns("long");
export const xsdint = /*#__PURE__*/ ns("int");
export const xsdshort = /*#__PURE__*/ ns("short");
export const xsdbyte = /*#__PURE__*/ ns("byte");
export const nonNegativeInteger = /*#__PURE__*/ ns("nonNegativeInteger");
export const unsignedLong = /*#__PURE__*/ ns("unsignedLong");
export const unsignedInt = /*#__PURE__*/ ns("unsignedInt");
export const unsignedShort = /*#__PURE__*/ ns("unsignedShort");
export const unsignedByte = /*#__PURE__*/ ns("unsignedByte");
export const positiveInteger = /*#__PURE__*/ ns("positiveInteger");
export const yearMonthDuration = /*#__PURE__*/ ns("yearMonthDuration");
export const dayTimeDuration = /*#__PURE__*/ ns("dayTimeDuration");
export const dateTimeStamp = /*#__PURE__*/ ns("dateTimeStamp");
/* Properties */
/* Other terms */
